// @ts-ignore
import type RouteMetadata from './route-data.json';
import { Language } from './types';

type RouteMetadata = typeof RouteMetadata;
type RemoveGroups<T> = T extends `${infer A}/(${string})${infer B}` ? `${A}${RemoveGroups<B>}` : T;

export type Locales =
    | 'de'
    | 'en'
    | 'es'
    | 'fr'
    | 'hi'
    | 'it'
    | 'pt'
    | 'ru'
    | 'tr'

export type RouteId = RemoveGroups<keyof RouteMetadata>;
export type Path<T extends RouteId> = T extends `/[[lang=lang]]${infer R}` ? R : T;

type Prettify<T> = { [K in keyof T]: T[K] } & {};
type ParseParam<T extends string> = T extends `...${infer Name}` ? Name : T;

type ParseParams<T extends string> = T extends `${infer A}[[${infer Param}]]${infer B}`
    ? ParseParams<A> & { [K in ParseParam<Param>]?: string } & ParseParams<B>
    : T extends `${infer A}[${infer Param}]${infer B}`
        ? ParseParams<A> & { [K in ParseParam<Param>]: string } & ParseParams<B>
        : // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        {};

export type Query = string | Record<string, string> | URLSearchParams;

type Options<T> = {
    params?: Prettify<ParseParams<T extends string ? T : never>>;
    baseUrl?: string;
    query?: Query;
    locale?: Locales;
};

export const getUrl = <T extends RouteId>(
    url: T,
    options?: Options<T>
): string => {
    let result = url as string;
    const search = options?.query && new URLSearchParams(options?.query).toString();
    Object.entries(options?.params ?? {}).forEach(([key, value]) => {
        result = result.replace(`[${key}]`, value as string);
    });
    return `${
        options?.baseUrl || ''
    }${
        options?.locale && options?.locale !== Language.English ? `/${options?.locale}` : ''
    }${result}${search ? `?${search}` : ''}`;
}

export enum Competitor {
    Omegle = 'omegle',
    Monkey = 'monkey',
    Flingster = 'flingster',
    OmeTV = 'ometv',
    Chatrandom = 'chatrandom',
    Coomeet = 'coomeet',
    Bazoocam = 'bazoocam',
    Dirtyroulette = 'dirtyroulette',
    Joingy = 'joingy',
}
